import { Action } from '@ngrx/store';
import { IUserSettings, LoginMethodStatus, ILoginMethodState } from '@app/profile/settings/settings';

export enum SettingsActionTypes {
  INITIALIZE = '[Settings] Initialize',
  CHANGE_THEME = '[Settings] Change Theme',
  CHANGE_LOGIN_METHOD = '[Settings] Change Login Method',
  REGISTER_EMAIL_SEND = '[Settings] Register email send',
  REGISTER_EMAIL_SUCCESS = '[Settings] Register email success',
  UPDATE_EMAILS_SUCCESS = '[Settings] Update emails success',
  REGISTER_EMAIL_ERROR = '[Settings] Register email error',
  REGISTER_PHONE_SEND = '[Settings] Register phone send',
  REGISTER_PHONE_SUCCESS = '[Settings] Register phone success',
  UPDATE_PHONES_SUCCESS = '[Settings] Update phones success',
  REGISTER_PHONE_ERROR = '[Settings] Register phone error',
  CLEAR_SETTINGS = '[Settings] Clear Settings',
  ERROR = '[Settings] Error'
}

export class ActionSettingsInitialize implements Action {
  readonly type = SettingsActionTypes.INITIALIZE;
  constructor(public payload: { settings: IUserSettings }) { }
}

export class ActionSettingsChangeTheme implements Action {
  readonly type = SettingsActionTypes.CHANGE_THEME;
  constructor(public payload: { theme: string }) { }
}

export class ActionSettingsChangeLoginMethod implements Action {
  readonly type = SettingsActionTypes.CHANGE_LOGIN_METHOD;
  constructor(public payload: { loginWithQR: boolean }) { }
}
export class ActionSettingsRegisterEmailSend implements Action {
  readonly type = SettingsActionTypes.REGISTER_EMAIL_SEND;
  constructor(public payload: { email: string, expTimestamp: number }) { }
}

export class ActionSettingsRegisterEmailSuccess implements Action {
  readonly type = SettingsActionTypes.REGISTER_EMAIL_SUCCESS;
  constructor(public payload: { loginEmail: string }) { }
}

export class ActionSettingsUpdateEmailsSuccess implements Action {
  readonly type = SettingsActionTypes.UPDATE_EMAILS_SUCCESS;
  constructor(public payload: { loginEmails: ILoginMethodState[] }) { }
}

export class ActionSettingsRegisterPhoneSend implements Action {
  readonly type = SettingsActionTypes.REGISTER_PHONE_SEND;
  constructor(public payload: { phoneNumber: string, expTimestamp: number }) { }
}

export class ActionSettingsRegisterPhoneSuccess implements Action {
  readonly type = SettingsActionTypes.REGISTER_PHONE_SUCCESS;
  constructor(public payload: { loginPhoneNumber: string }) { }
}

export class ActionSettingsUpdatePhonesSuccess implements Action {
  readonly type = SettingsActionTypes.UPDATE_PHONES_SUCCESS;
  constructor(public payload: { loginPhoneNumbers: ILoginMethodState[] }) { }
}

export class ActionSettingsClearSettings implements Action {
  readonly type = SettingsActionTypes.CLEAR_SETTINGS;
}

export class ActionSettingsError implements Action {
  readonly type = SettingsActionTypes.ERROR;
}

export type SettingsActions =
  | ActionSettingsInitialize
  | ActionSettingsChangeTheme
  | ActionSettingsChangeLoginMethod
  | ActionSettingsRegisterEmailSend
  | ActionSettingsRegisterEmailSuccess
  | ActionSettingsUpdateEmailsSuccess
  | ActionSettingsRegisterPhoneSend
  | ActionSettingsRegisterPhoneSuccess
  | ActionSettingsUpdatePhonesSuccess
  | ActionSettingsClearSettings
  | ActionSettingsError;

export const initialState: ISettingsState = {
  theme: 'DEFAULT-THEME',
  loginWithQR: false,
  loginEmail: null,
  loginPhoneNumber: null
};

export const selectorSettings = state =>
  (state.settings || initialState) as ISettingsState;

export function settingsReducer(
  state: ISettingsState = initialState,
  action: SettingsActions
): ISettingsState {

  switch (action.type) {
    case SettingsActionTypes.CHANGE_THEME:
      return { ...state, theme: action.payload.theme };

    case SettingsActionTypes.CHANGE_LOGIN_METHOD:
      return { ...state, loginWithQR: action.payload.loginWithQR };

    case SettingsActionTypes.REGISTER_EMAIL_SEND:
      return {
        ...state,
        loginEmail: {
          value: action.payload.email,
          status: LoginMethodStatus.inactive,
          expTimestamp: action.payload.expTimestamp
        }
      };

    case SettingsActionTypes.REGISTER_EMAIL_SUCCESS:
      return {
        ...state,
        loginEmail: {
          value: action.payload.loginEmail,
          status: LoginMethodStatus.active,
          expTimestamp: null
        }
      };

    case SettingsActionTypes.UPDATE_EMAILS_SUCCESS:
      return {
        ...state,
        loginEmails: action.payload.loginEmails
      };

    case SettingsActionTypes.REGISTER_PHONE_SEND:
      return {
        ...state,
        loginPhoneNumber: {
          value: action.payload.phoneNumber,
          status: LoginMethodStatus.inactive,
          expTimestamp: action.payload.expTimestamp
        }
      };

    case SettingsActionTypes.REGISTER_PHONE_SUCCESS:
      return {
        ...state,
        loginPhoneNumber: {
          value: action.payload.loginPhoneNumber,
          status: LoginMethodStatus.active,
          expTimestamp: null
        }
      };

    case SettingsActionTypes.UPDATE_PHONES_SUCCESS:
      return {
        ...state,
        loginPhoneNumbers: action.payload.loginPhoneNumbers
      };

    case SettingsActionTypes.INITIALIZE:
      // const email = action.payload.settings ? action.payload.settings.loginEmail : null;
      const emails = action.payload.settings ? action.payload.settings.loginEmails : null;
      // const phoneNumber = action.payload.settings ? action.payload.settings.loginPhoneNumber : null;
      const phoneNumbers = action.payload.settings ? action.payload.settings.loginPhoneNumbers : null;
      return {
        ...state,
        // loginEmail: email,
        loginEmails: emails,
        // loginPhoneNumber: phoneNumber,
        loginPhoneNumbers: phoneNumbers
      };

    case SettingsActionTypes.CLEAR_SETTINGS:
      return null;

    default:
      return state;
  }
}

export interface ISettingsState {
  theme: string;
  loginWithQR: boolean;
  loginEmail?: ILoginMethodState;
  loginEmails?: ILoginMethodState[];
  loginPhoneNumber?: ILoginMethodState;
  loginPhoneNumbers?: ILoginMethodState[];
}
